import { Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { SimpleTooltip } from 'v5/design-system/Tooltip';
import { cn } from 'v5/platform/dom/cn';

export type GlobalCustomFieldHintProps = {
  className?: string;
};

/**
 * Quiet globe affordance for custom fields that write the shared global value
 * under a workspace URL (assignment-origin write lens).
 *
 * Parent should place this in a flex row with `items-center` next to the label.
 */
export function GlobalCustomFieldHint({
  className
}: GlobalCustomFieldHintProps) {
  const { t } = useTranslation('patterns', {
    keyPrefix: 'GlobalCustomFieldHint'
  });

  return (
    <SimpleTooltip
      title={t('tooltip')}
      delayDuration={300}
      align="start"
      side="bottom"
    >
      <button
        type="button"
        className={cn(
          'inline-flex size-3.5 shrink-0 items-center justify-center p-0',
          'appearance-none border-0 bg-transparent leading-none',
          'rounded-sm text-current/70 hover:text-current',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-focus',
          className
        )}
        aria-label={t('ariaLabel')}
        onClick={event => {
          event.preventDefault();
          event.stopPropagation();
        }}
      >
        <Globe className="size-3.5" strokeWidth={1.75} aria-hidden />
      </button>
    </SimpleTooltip>
  );
}
